import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { FixtureProfileResponse } from "~types/fixtureProfile";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectFixtureProfile = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();

  const onConvertResponseIntoOptionsHandler = (response: FixtureProfileResponse) =>
    (response?.data || []).map((x) => ({
      label: x.defaultProfile ? formatMessage({ id: "fixture.select.profile.default" }, { label: x.name }) : x.name,
      value: x.profileId,
    }));

  return (
    <InfinitySelect<FixtureProfileResponse>
      {...props}
      url={`${sport}/o/${organizationId}/fixtureProfiles`}
      searchParameter="nameContains"
      values={value ? [value] : []}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.MATCH_PROFILE}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
